// =============================================================================
// Mention matching — shared between the unread badge and the mention chime.
// =============================================================================
// This mirrors the backend's MENTION_RE (backend/src/services/notifications.ts),
// which decides who gets pushed. Keep the two in sync: if the client thinks a
// message is a mention but the server doesn't (or vice-versa), the badge, the
// chime, and the push notification disagree with each other.
//
// Matching is deliberately whole-token: "@sam" must not fire for user "samuel",
// and vice-versa. Substring matching here previously caused false mention
// badges when one username contained another.
// =============================================================================

/** Escape regex metacharacters — usernames may contain '.' or '-'. */
function escapeRe(s: string): string {
  return s.replace(/[.*+?^${}()|[\]\\-]/g, '\\$&');
}

/**
 * True if `content` @-mentions `username`, @everyone, or @here.
 *
 * Returns false when `username` is undefined (no signed-in user), so callers
 * can pass `me?.username` directly.
 */
export function isMention(content: string, username: string | undefined): boolean {
  if (!username) return false;
  const u = escapeRe(username);
  return new RegExp(`(?<![\\w@])@(?:${u}|everyone|here)(?![\\w])`, 'i').test(content);
}
